function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useEffect, useContext, useRef } from 'react';
import { history } from 'dumi';
import { context } from 'dumi/theme';
import TouchEmulator from 'f2-touchemulator';
import vl from 'umi-hd';
import flex from 'umi-hd/lib/flex';
import vw from 'umi-hd/lib/vw';
import vh from 'umi-hd/lib/vh';
export var ROUTE_MSG_TYPE = 'dumi:update-iframe-route'; // available HD modes

var HD_MODES = {
  vl: vl,
  flex: flex,
  vw: vw,
  vh: vh
};
var isSupportTouch = ('ontouchstart' in window);

var MobileDemoLayout = function MobileDemoLayout(_ref) {
  var children = _ref.children;

  var _useContext = useContext(context),
      config = _useContext.config;

  var target = useRef(null);
  var _ref2 = config.theme,
      _ref2$hd = _ref2.hd;
  _ref2$hd = _ref2$hd === void 0 ? {} : _ref2$hd;
  var _ref2$hd$rules = _ref2$hd.rules,
      rules = _ref2$hd$rules === void 0 ? [{
    mode: 'vw',
    options: [100, 750]
  }] : _ref2$hd$rules;
  useEffect(function () {
    // Simulate the touch event of mobile terminal
    if (target.current && !isSupportTouch) {
      // fix https://github.com/umijs/dumi/issues/996
      TouchEmulator(document);
    } // listen route change message


    var handler = function handler(ev) {
      if (ev.data.type === ROUTE_MSG_TYPE) {
        history.push(ev.data.value);
      }
    };

    window.addEventListener('message', handler);
    return function () {
      return window.removeEventListener('message', handler);
    };
  }, []);
  useEffect(function () {
    var handler = function handler() {
      var clientWidth = document.documentElement.clientWidth;
      rules // discard invalid rules
      .filter(function (rule) {
        return HD_MODES[rule.mode];
      }) // match first valid rule
      .some(function (rule) {
        if ( // without min & max width
        Number.isNaN(rule.minWidth * 1) && Number.isNaN(rule.maxWidth * 1) || // min width only
        Number.isNaN(rule.maxWidth * 1) && clientWidth > rule.minWidth || // max width only
        Number.isNaN(rule.minWidth * 1) && clientWidth < rule.maxWidth || // both min & max width
        clientWidth > rule.minWidth && clientWidth < rule.maxWidth) {
          HD_MODES[rule.mode].apply(HD_MODES, _toConsumableArray([].concat(rule.options)));
          document.documentElement.setAttribute('data-scale', 'true');
          return true;
        }
      });
    };

    handler();
    window.addEventListener('resize', handler);
    return function () {
      return window.removeEventListener('resize', handler);
    };
  }, [rules]);
  return /*#__PURE__*/React.createElement("div", {
    className: "__dumi-default-mobile-demo-layout",
    ref: target
  }, children);
};

export default MobileDemoLayout;